import $ from 'jquery';
import './external-link-modal';
import './video-modal';
$(function () {
  var $body = $('body');
  var $modalCloses = $('.close');
  var $modalTriggers = $('.modal-trigger');
  $modalCloses.on('click touch', closeModal);
  $modalTriggers.on('click touch', openModal);
  function closeModal() {
    var $trigger = $(this);
    var $modal = $trigger.closest('.modal');
    $body.removeClass('overflow-hidden');
    $modal.removeClass('active');
    $body.off('click touch', onBodyClick);
  }
  function onBodyClick(event) {
    var $target = $(event.target);
    if (!$target.hasClass('modal')) {
      return;
    }
    var $trigger = $target.find('.close');
    closeModal.call($trigger.get(0));
  }
  function openModal() {
    var $trigger = $(this);
    var $modal = $("#".concat($trigger.data('target')));
    $body.addClass('overflow-hidden');
    $modal.addClass('active');
    $body.on('click touch', onBodyClick);
  }
});